import ButtonComponent from '~/components/ui/button/index.vue';

export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.vueApp.component('btn', ButtonComponent)
});